import { c as _c } from "react/compiler-runtime";
import { useCurrency, usePersona, useRouter } from "@opensea/navigation";
import { isTypingInInputField } from "@opensea/ui-kit";
import { useEventListener, useOnChange } from "@opensea/ui-kit/hooks";
import { useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { useKeybindModalStore } from "@/stores/use-keybind-modal-store";
import { useKeybinds } from "./keybinds";
export function useKeyboardShortcuts() {
  const $ = _c(9);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [history, setHistory] = useState(t0);
  const keybinds = useKeybinds();
  const {
    togglePersona
  } = usePersona();
  const {
    toggleCurrency
  } = useCurrency();
  const {
    setModalOpen
  } = useKeybindModalStore(useShallow(_temp));
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      if (isTypingInInputField()) {
        return;
      }
      setHistory(prev => [...prev, event.key]);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEventListener("keydown", t1);
  let t2;
  if ($[2] !== history || $[3] !== keybinds || $[4] !== router || $[5] !== setModalOpen || $[6] !== toggleCurrency || $[7] !== togglePersona) {
    t2 = () => {
      const keybindKey = [history.at(-2), history.at(-1)].join("").toLowerCase();
      if (!(keybindKey in keybinds)) {
        return;
      }
      const keybind = keybinds[keybindKey];
      if (!keybind.action) {
        return;
      }
      bb16: switch (keybind.action.action) {
        case "redirect":
          {
            router.push(keybind.action.url);
            break bb16;
          }
        case "help":
          {
            setModalOpen(true);
            break bb16;
          }
        case "toggle":
          {
            bb18: switch (keybind.action.type) {
              case "persona":
                {
                  togglePersona();
                  break bb18;
                }
              case "currency":
                {
                  toggleCurrency();
                }
            }
          }
      }
      setHistory([]);
    };
    $[2] = history;
    $[3] = keybinds;
    $[4] = router;
    $[5] = setModalOpen;
    $[6] = toggleCurrency;
    $[7] = togglePersona;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useOnChange(history, t2);
}
function _temp(state) {
  return {
    setModalOpen: state.setModalOpen
  };
}